import { get, isNil, omitBy } from 'lodash';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import cookies from 'js-cookie';

export const PREVIEW_CHURNED_SEARCH_QUERY = gql`
    query search($parameters: SearchParameters!, $specialtyId: String!) {
        search(parameters: $parameters) {
            searchResponse {
                providerLocations {
                    id
                    provider {
                        id
                        monolithId
                        approvedFullName
                        averageRating
                        canHaveAppointments
                        frontEndCirclePictureUrl
                        defaultProcedureId
                        firstName
                        isPreview
                        lastName
                        nameInSentence
                        postnominal
                        prenominal
                        profileUrl
                        status
                        relevantSpecialty(searchSpecialtyId: $specialtyId) {
                            id
                            name
                        }
                        reviewCount
                    }
                    location {
                        id
                        isVirtual
                        monolithId
                        address1
                        address2
                        city
                        latitude
                        longitude
                        name
                        phone
                        state
                        zipCode
                    }
                }
                searchUrl
            }
        }
    }
`;

export const gqlOptions = ({
    location,
    procedureId,
    specialtyId,
    carrierId,
    planId,
}) => {
    const rankBy = 'Default';
    // directory-service seems to default the count if its 0, so I'm going to specify a small amount
    const itemQuantity = 1;

    const directoryId = '-1';
    const insuranceCarrierId = carrierId || '-1';
    const insurancePlanId = planId || '-1';

    const bsid = cookies.get('bsid');
    const firstTimeVisitor = cookies.get('firstTimeVisitor');

    // remove timestamp from browser session id cookie
    const sessionId =
        !bsid || bsid === null ? null : bsid.substr(0, bsid.indexOf('_'));
    const trackingId = firstTimeVisitor || null;

    // use active location for lat long
    const { latitude, longitude } = location;

    const coordinates =
        latitude && longitude
            ? {
                  latitude,
                  longitude,
              }
            : null;

    const searchLocation = { coordinates };

    const searchParams = omitBy(
        {
            directoryId,
            itemQuantity,
            insuranceCarrierId,
            insurancePlanId,
            rankBy,
            searchLocation,
            sessionId,
            specialtyId,
            trackingId,
        },
        isNil
    );

    searchParams.excludePreviewProviders = true;
    searchParams.requestedFacets = ['procedures'];
    searchParams.callerType = 'booking';

    searchParams.filters = [
        {
            name: 'procedures',
            values: [procedureId],
        },
        {
            name: 'is_virtual_location',
            values: ['b64_b2ZmZXJzIHZpZGVvIHZpc2l0cw=='],
        },
    ];

    return {
        errorPolicy: 'all',
        ssr: false,
        variables: {
            includeCustomProviderProps: false,
            parameters: searchParams,
            specialtyId,
        },
    };
};

export function parseSearchGql({ data }) {
    if (data.loading) return { providerLoading: true };
    if (data.error) return { hasErrors: true };

    let providerLocations = get(
        data,
        'search.searchResponse.providerLocations'
    );

    const searchUrl = get(data, 'search.searchResponse.searchUrl');

    if (providerLocations && providerLocations.length > 3) {
        providerLocations = providerLocations
            .filter(pl => pl.location.isVirtual)
            .slice(0, 3);
    }
    return { providerLocations, searchUrl };
}

export const withSearchResults = graphql(PREVIEW_CHURNED_SEARCH_QUERY, {
    notifyOnNetworkStatusChange: true,
    options: gqlOptions,
    props: parseSearchGql,
    skip: ({ location }) => !location,
});
